export const resetPasswordStyles = {
  container: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    padding: '2rem',
    width: '100%',
    maxWidth: '400px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
  },
  title: {
    marginBottom: '2rem',
    fontWeight: 'bold',
    fontFamily: "'Caveat', cursive",
  },
  subtitle: {
    marginBottom: '1rem',
    textAlign: 'center' as const,
  },
  description: {
    marginBottom: '2rem',
    textAlign: 'center' as const,
    color: '#666',
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column' as const,
  },
  input: {
    marginBottom: '1rem',
  },
  submitButton: {
    marginTop: '1rem',
    height: '48px',
  },
  backToLoginLink: {
    textAlign: 'center' as const,
    marginTop: '1.5rem',
  },
};
